export default (that, disabled) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('form_label_picture') || '图片',
    align: 'center',
    slots: { default: 'defaultImageUrl' },
  },
  {
    visible: !disabled && !that.buttonFlag,
    width: 40,
    headerAlign: 'center',
    align: 'center',
    slots: {
      default: 'opt1',
    },
    titleHelp: {
      message:
        that.$l('Press_and_hold_and_drag_to_adjust_the_list_order!') ||
        '按住后拖拽，可调整列表顺序！',
    },
  },
  {
    field: 'materialNo',
    align: 'left',
    headerAlign: 'left',
    minWidth: 180,
    title: that.$l('table_label_accessories_no') || '辅料编号',
    showHeaderOverflow: 'title',
    slots: { default: 'materialNoInfo' },
  },
  {
    field: 'materialName',
    align: 'left',
    headerAlign: 'left',
    minWidth: 230,
    title: that.$l('table_label_accessories_name') || '辅料名称',
    showHeaderOverflow: 'title',
    slots: { default: 'materialNameInfo' },
  },
  {
    field: 'materialDesc',
    align: 'left',
    headerAlign: 'left',
    minWidth: 180,
    title: that.$l('table_label_material_desc') || '辅料材质',
    showHeaderOverflow: 'title',
  },
  {
    field: 'materialSpec',
    align: 'left',
    headerAlign: 'left',
    minWidth: 180,
    title: that.$l('table_label_material_spec') || '辅料规格',
    showHeaderOverflow: 'title',
  },
  {
    field: 'usageQty',
    align: 'center',
    headerAlign: 'center',
    minWidth: 120,
    title: that.$l('table_label_accessories_usage_qty') || '辅料用量',
    showHeaderOverflow: 'title',
  },
  {
    field: 'qtyUnit',
    align: 'center',
    headerAlign: 'center',
    minWidth: 120,
    title: that.$l('table_label_accessories_unit') || '辅料单位',
    showHeaderOverflow: 'title',
    slots: { default: 'qtyUnitInfo' },
  },
  {
    field: 'price',
    align: 'center',
    headerAlign: 'center',
    minWidth: 120,
    title: that.$l('table_label_price') || '单价',
    showHeaderOverflow: 'title',
    slots: { default: 'price' },
  },
  {
    field: 'subTotal',
    align: 'center',
    headerAlign: 'center',
    minWidth: 120,
    title: that.$l('table_label_subTotal') || '成本小计',
    showHeaderOverflow: 'title',
    isTotalColumn: true,
  },
  {
    field: 'scmName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 220,
    title: that.$l('table_hand_nameOfManufacturer') || '厂商名称',
    showHeaderOverflow: 'title',
  },
  {
    visible: !disabled,
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 85,
    fixed: 'right',
    slots: {
      default: 'opt',
    },
  },
]
